module.exports = __webpack_public_path__ + "static/img/1.3f60bd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/1.png
// module id = X+Ht
// module chunks = 0